var map = {
	"./accessibleparking.png": 375,
	"./accessibletoilet.png": 587,
	"./atm.png": 118,
	"./attraction.png": 939,
	"./babychanging.png": 318,
	"./bikerack.png": 930,
	"./blue-dot.png": 53,
	"./defibrillator.png": 708,
	"./examlocations.png": 361,
	"./foodoutlet.png": 127,
	"./gradient.png": 160,
	"./graduation.png": 625,
	"./logo.png": 949,
	"./offerholdersday.png": 659,
	"./periodproduct.png": 884,
	"./prayerandreflection.png": 267,
	"./repairs.png": 148,
	"./retailoutlet.png": 597,
	"./secondary_marker.png": 143,
	"./shower.png": 365,
	"./studentsupportofficer.png": 712,
	"./toilet.png": 730,
	"./waterfountain.png": 844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;